export default __webpack_public_path__ + "static/093-e556a5426c925a70e50b1e2798ed1308.jpg";